import { Box, Typography } from '@mui/material'

type FormRowProps = {
  label: string
  children: React.ReactNode
  pt?: number
}

const FormRow = ({ label, children, pt = 1 }: FormRowProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
      <Typography
        sx={{
          minWidth: 180,
          fontWeight: 500,
          color: 'text.secondary',
          pt,
        }}
      >
        {label}
      </Typography>

      <Box sx={{ flex: 1 }}>{children}</Box>
    </Box>
  )
}

export default FormRow
